export const environment = {
    production: false,
    googleAnalyticsMeasurementId: '',
    isMockEnabled: false, // You have to switch this, when your real back-end is done
    authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
    ipserver: 'https://fyf-dev.fyffes-na.com/',
    prebookserver: 'https://fyf-dev.fyffes-na.com/',
	holidayserver: 'https://date.nager.at/api/v3/publicholidays',
    host: 'https://fyf-dev.fyffes-na.com/fyffesna/',
	operationserver:'http://localhost:8080/',
    autorizationLevelKey: 'salesPerson',
    partCodeEntityKey: 'partCode',
	allValuesKey: 'ALL',
	productClassEntityKey: 'productClass',
    bypassComplaintEntityKey: 'complaintActions',
    warehouseEntityKey: 'warehouse',
    warehouseReceptionEntityKey: 'Warehouse_Receive_Ship',
    warehouseShipmentEntityKey: 'Warehouse_Receive_Ship',
    warehouseOrderReleases: 'orderReleasesWarehouse',
    entitiesProcessDays: 'truckReceiptProcessDays',
	containerReportEntityKey: 'containerReport',
	containerReportActionEntityKey: 'containerReportAction',
	warehouseReportActionEntityKey: 'WarehouseReportAction',
    invoiceSearchActionEntityKey: 'processByInquiry',
	ediCustomersEntityKey: 'ediCustomers',
    notificationEntityKey: 'notification',
	technicalDocumentsEntityKey: 'technicalDocuments',
	warehouseLazyScanEntityKey: 'warehouseLazyScan',
	productClassManagerEntityKey: 'productClassManager',
    assignDoorEntityKey: 'AssignDoor',
    assignDoorInEntityKey: 'AssignDoorIn',
    assignDoorOutEntityKey: 'AssignDoorOut',
    EDIGetSourceEntityKey: 'EDIGetSourceFiles',
    EDISendSourceEntityKey: 'EDISendSourceFiles',
    EDIGetSourceDiscrepancyResolutionEntityKey: 'EDIDiscrepancyResolution',
    businessAnalystEntityKey: 'businessAnalyst',
    averagePercent: 20,
    fyffesWIapk:'https://fyf-qas.fyffes-na.com/fyffesna/android/app.apk',
    fyffesWIiOs:'https://apps.apple.com/app/fyffeshub/id6479165223',
	// Injected at build time from pipeline OPENAI_API_KEY — never commit keys
	openAIKey: '',
	openAIAssistantId:'asst_MOtQR1Q15haYp0TPirb2Lmvc'};

/** Runtime OpenAI key from window.__env (injected at build from pipeline OPENAI_API_KEY). */
export function getOpenAIKey(): string {
  const runtimeKey = typeof window !== 'undefined' ? (window as any).__env?.openAIKey : '';
  return (runtimeKey && runtimeKey.trim()) || environment.openAIKey;
}
